import type { StatsDto } from '@flightlog/shared';
import { plural } from '../format';

const EARTH_KM = 40_075;

function number(value: number): string {
  return Math.round(value).toLocaleString('ru-RU');
}

/** Табло сверху «Моих полётов»: главные цифры и сколько раз облетел Землю. */
export function Board({ stats }: { stats: StatsDto }) {
  const km = stats.totalDistanceKm;
  const laps = km / EARTH_KM;
  const done = Math.floor(laps);
  const left = (done + 1) * EARTH_KM - km;
  const hours = stats.totalDurationMin / 60;

  return (
    <section className="board" aria-label="Итоги">
      <div className="board-grid">
        <div className="board-cell">
          <b>{number(stats.totalFlights)}</b>
          <span>{plural(stats.totalFlights, ['рейс', 'рейса', 'рейсов'])}</span>
        </div>
        <div className="board-cell">
          <b>{number(km)}</b>
          <span>км</span>
        </div>
        <div className="board-cell">
          <b>{number(stats.countries)}</b>
          <span>{plural(stats.countries, ['страна', 'страны', 'стран'])}</span>
        </div>
        <div className="board-cell">
          <b>
            {stats.estimatedFlights > 0 ? <small>≈</small> : null}
            {number(hours)}
          </b>
          <span>{plural(Math.round(hours), ['час', 'часа', 'часов'])} в воздухе</span>
        </div>
      </div>

      <div className="board-earth">
        <div className="board-earth-head">
          <span>Облёт Земли</span>
          <b>×{laps.toLocaleString('ru-RU', { maximumFractionDigits: 1 })}</b>
        </div>
        <div className="board-track" role="img" aria-label={`Пройдено ${Math.round((laps - done) * 100)}% круга`}>
          <div className="board-fill" style={{ width: `${(laps - done) * 100}%` }} />
        </div>
        <p className="board-note">
          до {done + 1}-го круга — {number(left)} км
          {stats.upcomingFlights > 0
            ? ` · впереди ${stats.upcomingFlights} ${plural(stats.upcomingFlights, ['рейс', 'рейса', 'рейсов'])}`
            : ''}
        </p>
      </div>
    </section>
  );
}
